var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPourcentStaffBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 111,
    viewBox: "0 0 125 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.13 40.6707C114.55 27.0807 104.11 15.8307 91.9604 7.1907C88.2004 4.51689 84.2679 2.08443 80.2165 0H34C27.1924 0 20.852 2.00074 15.5349 5.44629C14.7144 6.07051 13.9091 6.71234 13.1204 7.3707C11.514 8.68745 9.97303 10.0716 8.49225 11.5193C3.20677 17.5118 0 25.3814 0 34V77C0 95.7777 15.2223 111 34 111H89.769C92.108 109.147 94.4645 107.362 96.7869 105.602C106.338 98.3641 115.313 91.5628 120.13 82.3407C126.43 70.3707 125.71 54.3507 120.13 40.6707Z",
    fill: "#A3EFC8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPourcentStaffBg);
export default __webpack_public_path__ + "static/media/pourcentStaffBG.fa99bb8237676fd7fe0d3daa5823ca82.svg";
export { ForwardRef as ReactComponent };